export default __webpack_public_path__ + "static/typescript-icon-9dfd9d9a74f1cd44f8a6fa4fdd5b13e5.svg";